import { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { Input, Select } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import Table from '../../../components/Table'
import { StaffRosterContext } from '../../../utils/context'
import { useSelector } from 'react-redux'

// Данные для дропдаунов
const educationTypes = [
  { name: '', value: '' },
  { name: 'Доп. образование', value: 'additional' },
  { name: 'Курсы повышения квалификации', value: 'courses' },
  { name: 'Профессиональная переподготовка', value: 'retraining' },
  { name: 'Стажировка', value: 'internship' },
  { name: 'Семинар', value: 'seminar' },
  { name: 'Вебинар', value: 'webinar' }
]

const educationForms = [
  { name: '', value: '' },
  { name: 'Очное', value: 'fulltime' },
  { name: 'Заочное', value: 'parttime' },
  { name: 'Очно-заочное', value: 'mixed' },
  { name: 'Дистанционное', value: 'distance' }
]

const courseTopics = [
  { name: '', value: '' },
  { name: 'Педагогика и методика преподавания', value: 'pedagogy' },
  { name: 'Информационные технологии в образовании', value: 'it_education' },
  { name: 'Психология образования', value: 'psychology' },
  { name: 'ФГОС и образовательные стандарты', value: 'fgos' },
  { name: 'Инклюзивное образование', value: 'inclusive' },
  { name: 'Современные образовательные технологии', value: 'modern_tech' },
  { name: 'Воспитательная работа', value: 'educational_work' },
  { name: 'Охрана труда и безопасность', value: 'safety' }
]


const qualificationTypes = [
  { name: '', value: '' },
  { name: 'повышение квалификации', value: 'qualification' },
  { name: 'профессиональная переподготовка', value: 'retraining' },
  { name: 'стажировка', value: 'internship' }
]



const API_TAB = 'professional_development'

const emptyRowData = {
  dateStart: '',
  dateEnd: '',
  educationType: '',
  educationForm: '',
  institution: '',
  documentType: '',
  documentNumber: '',
  documentDate: '',
  basis: '',
  specialty: '',
  courseTopic: '',
  hours: '',
  lecturer: '',
  qualificationType: ''
}

export default function Qualification() {
  const { allForms, trackDeletion } = useContext(StaffRosterContext)
  const { values, setFieldValue } = allForms

  // Данные из API (Redux)
  const { personTabData } = useSelector(state => state.personnel)
  const { qualification: apiQualification } = personTabData || {}

  // Локальные состояния для UI
  const [selectedRow, setSelectedRow] = useState(null)
  const [isAddingRow, setIsAddingRow] = useState(false)
  const [newRowData, setNewRowData] = useState(emptyRowData)

  // Данные таблицы берем из Formik
  const tableData = values.qualification || []

  // Синхронизация API данных с Formik (только при первой загрузке)
  useEffect(() => {
    if (apiQualification && !tableData.length) {
      setFieldValue('qualification', apiQualification)
    }
  }, [apiQualification, tableData.length, setFieldValue])

  // Проверка заполненности обязательных полей (минимум: даты, вид, учреждение)
  const isNewRowComplete =
    newRowData.dateStart.trim() !== '' &&
    newRowData.dateEnd.trim() !== '' &&
    newRowData.educationType.trim() !== '' &&
    newRowData.institution.trim() !== ''

  const handleRowSelect = (id) => {
    setSelectedRow(selectedRow === id ? null : id)
  }

  const handleAddRow = () => {
    setIsAddingRow(true)
    setNewRowData(emptyRowData)
  }

  const handleNewRowChange = (e) => {
    const { name, value } = e.target
    setNewRowData(prev => ({ ...prev, [name]: value }))
  }

  const handleConfirmAdd = () => {
    const newRow = {
      id: `new_${Date.now()}`,
      date_start: newRowData.dateStart,
      date_end: newRowData.dateEnd,
      education_type: newRowData.educationType,
      education_form: newRowData.educationForm,
      institution: newRowData.institution,
      document_type: newRowData.documentType,
      document_number: newRowData.documentNumber,
      document_date: newRowData.documentDate,
      basis: newRowData.basis,
      specialty: newRowData.specialty,
      course_topic: newRowData.courseTopic,
      hours: newRowData.hours,
      lecturer: newRowData.lecturer,
      qualification_type: newRowData.qualificationType
    }
    // Сохраняем в Formik
    setFieldValue('qualification', [...tableData, newRow])
    setIsAddingRow(false)
    setNewRowData(emptyRowData)
  }

  const handleCancelAdd = () => {
    setIsAddingRow(false)
    setNewRowData(emptyRowData)
  }

  const handleDeleteRow = () => {
    if (selectedRow !== null) {
      const rowToDelete = tableData.find(row => (row.id || row.xp_key) === selectedRow)
      if (rowToDelete) {
        const pk = rowToDelete.xp_key || rowToDelete.id || rowToDelete.xp_fm_id
        // Трекаем удаление только для существующих записей (не для новых)
        if (pk && !String(pk).startsWith('new_')) {
          trackDeletion(API_TAB, pk)
        }
      }
      // Обновляем в Formik
      const updatedData = tableData.filter(row => (row.id || row.xp_key) !== selectedRow)
      setFieldValue('qualification', updatedData)
      setSelectedRow(null)
    }
  }

  const renderOptions = ({ name, value }) => (
    <option key={value || 'empty'} value={value}>{name}</option>
  )

  return (
    <div className={styles.tabWrapper}>
      {/* Таблица */}
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Дата начала</th>
              <th>Дата окончания</th>
              <th>Вид</th>
              <th>Форма</th>
              <th>Наименование ОУ</th>
              <th>Документ</th>
              <th>Номер</th>
              <th>Дата док.</th>
              <th>Основание</th>
              <th>Специальность</th>
              <th>Тема</th>
              <th>Часы</th>
              <th>Лектор</th>
              <th>ПК</th>
              <th>ПП</th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map(row => {
                const qualType = row.qualification_type || row.qualificationType || ''
                return (
                  <tr
                    key={row.id || row.xp_key}
                    onClick={() => handleRowSelect(row.id || row.xp_key)}
                    className={selectedRow === (row.id || row.xp_key) ? styles.selectedRow : ''}
                  >
                    <td>{row.date_start || row.dateedubegin || row.dateStart || ''}</td>
                    <td>{row.date_end || row.dateedu || row.dateEnd || ''}</td>
                    <td>{row.education_type || row.type || ''}</td>
                    <td>{row.education_form || row.form || ''}</td>
                    <td>{row.institution || ''}</td>
                    <td>{row.document_type || row.docname || ''}</td>
                    <td>{row.document_number || row.docnum || ''}</td>
                    <td>{row.document_date || row.docdate || ''}</td>
                    <td>{row.basis || row.doctext || ''}</td>
                    <td>{row.specialty || row.docspec || ''}</td>
                    <td>{row.course_topic || row.tema || ''}</td>
                    <td>{row.hours || ''}</td>
                    <td>{row.lecturer || row.lector || ''}</td>
                    <td>{qualType === 'qualification' ? '✓' : ''}</td>
                    <td>{qualType === 'retraining' ? '✓' : ''}</td>
                  </tr>
                )
              })
            ) : !isAddingRow ? (
              <tr>
                <td colSpan="15" className={styles.emptyTable}>
                  Нет данных о повышении квалификации
                </td>
              </tr>
            ) : null}
            {isAddingRow && (
              <tr className={styles.editableRow}>
                <td>
                  <Input type="date" name="dateStart" value={newRowData.dateStart} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Input type="date" name="dateEnd" value={newRowData.dateEnd} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Select name="educationType" value={newRowData.educationType} onChange={handleNewRowChange}>
                    {educationTypes.map(renderOptions)}
                  </Select>
                </td>
                <td>
                  <Select name="educationForm" value={newRowData.educationForm} onChange={handleNewRowChange}>
                    {educationForms.map(renderOptions)}
                  </Select>
                </td>
                <td>
                  <Input name="institution" value={newRowData.institution} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Input name="documentType" value={newRowData.documentType} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Input name="documentNumber" value={newRowData.documentNumber} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Input type="date" name="documentDate" value={newRowData.documentDate} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Input name="basis" value={newRowData.basis} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Input name="specialty" value={newRowData.specialty} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Select name="courseTopic" value={newRowData.courseTopic} onChange={handleNewRowChange}>
                    {courseTopics.map(renderOptions)}
                  </Select>
                </td>
                <td>
                  <Input type="number" name="hours" value={newRowData.hours} onChange={handleNewRowChange} min="1" />
                </td>
                <td>
                  <Input name="lecturer" value={newRowData.lecturer} onChange={handleNewRowChange} />
                </td>
                <td colSpan="2">
                  <Select name="qualificationType" value={newRowData.qualificationType} onChange={handleNewRowChange}>
                    {qualificationTypes.map(renderOptions)}
                  </Select>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <div className={styles.qualificationButtonsInline}>
            {!isAddingRow ? (
              <>
                <Button onClick={handleAddRow}>+ Добавить строку</Button>
                <Button mode="delete" onClick={handleDeleteRow}>× Удалить строку</Button>
              </>
            ) : (
              <>
                {isNewRowComplete && (
                  <Button onClick={handleConfirmAdd}>Сохранить</Button>
                )}
                <Button mode="delete" onClick={handleCancelAdd}>Отмена</Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
